/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { Beneficiary } from "./Beneficiary";

export const productAASamplingIntervals = [
    { name: "month", label: "Mensuel" },
    { name: "trimester", label: "Trimestriel" }
];

export interface ProductAA {
    
    isGPAT?: boolean;
    GPATAnnuity?: number;
    GPATContribution?: number;

    isGPAP?: boolean;
    GPAPAnnuity?: number;
    GPAPContribution?: number;

    isGCA?: boolean;
    GCACapital?: number;
    GCAContribution?: number;

    isGA?: boolean;

    contribution?: number;
    contributionMax?: number;
    samplingInterval?: "month" | "trimester";

    beneficiaries: Beneficiary[];
}



// WEBPACK FOOTER //
// ./src/types/ProductAA.ts